// extracted by mini-css-extract-plugin
export default {"container":"AdvFullscreenContainer__container--kqD-4"};